<template>
  <div
    class="phone-code-button"
    :class="[{ 'phone-code-button--error': error }, { 'phone-code-button--disabled': disabled }]"
    @click="emit('open')"
  >
    <div ref="parentRef" class="phone-code-button__code">
      <span v-if="selectedCountry" :key="selectedCountry.iso2" class="phone-code-button__selected">
        <span class="phone-code-button__flag">
          <UICountryIcon :key="selectedCountry.iso2" :iso2="selectedCountry.iso2"></UICountryIcon>
        </span>
        {{ selectedCountry.phone_code }}
      </span>
      <span v-else class="phone-code-button__code-placeholder"> Code </span>
      <UIIcon
        class="phone-code-button__chevron"
        name="chevron-big-filled-down"
        :class="{ 'phone-code-button__chevron--open': menuVisible }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PhoneCountryOption } from '~/types/ui'

defineProps<{
  selectedCountry?: PhoneCountryOption
  menuVisible: boolean
  error?: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'open'): void
}>()

const [parentRef] = useAutoAnimate()
</script>

<style scoped lang="scss">
@use '@/styles/variables.scss' as *;

.phone-code-button {
  user-select: none;

  &__selected {
    display: flex;
    align-items: center;
    color: $black-100;
  }

  &__flag {
    width: 24px;
    height: 16px;
    margin-right: 8px;
  }

  &__code {
    display: flex;
    align-items: center;
    border: $base-border-width solid $black-20;
    height: 32px;
    border-radius: $base-border-radius;
    padding: 0 8px;
    font-size: 14px;
    color: $black-70;
    cursor: pointer;
    transition: $base-transition border, $base-transition width;

    @media screen and (max-width: 1023px) {
      border-radius: 8px;
    }

    &-placeholder {
      color: $black-40;
    }
  }

  &__chevron {
    margin-left: 4px;
    transition: $base-transition transform;

    &--open {
      transform: rotate(180deg);
    }
  }

  &--error {
    .phone-code-button__code {
      border-color: $error-100;
    }
  }

  &--disabled {
    .phone-code-button__selected {
      color: $black-60;
    }
  }
}
</style>
